module.exports = __webpack_public_path__ + "static/media/nginx.6e4f1eee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/nginx.png
// module id = 155
// module chunks = 0